import { render, staticRenderFns } from "./Xs500GrayCaps.vue?vue&type=template&id=2058bfe1&scoped=true&"
var script = {}
import style0 from "./Xs500GrayCaps.vue?vue&type=style&index=0&id=2058bfe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058bfe1",
  null
  
)

export default component.exports